import { useQuery } from '@tanstack/react-query'

import { useBoundStore } from '../store/store'
import type { ApiResponse } from '../types/api'
import { api } from '../utils/api-client'
import { queryKeys } from './queries/keys'

const useUnreadMessages = () => {
  const username = useBoundStore(state => state.user.username)

  const { data } = useQuery<number>({
    queryKey: [...queryKeys.unread_messages, username],
    queryFn: async ({ signal }) => {
      const response = await api.post<ApiResponse<string>>(
        '/ajax_data.php',
        { type: 'noread_message' },
        { signal },
      )
      const { status, info } = response.data
      return status === 1 ? parseInt(info) : 0
    },
    enabled: Boolean(username),
    refetchOnWindowFocus: false,
    staleTime: 0,
  })

  return { noOfUnread: data ?? 0 }
}

export default useUnreadMessages
